import React from 'react';
import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './ContactInfo.module.css';
import ContactInfoPhoneNumber from '../ContactInfoPhoneNumber/ContactInfoPhoneNumber';
import ContactInfoAddress from '../ContactInfoAddress/ContactInfoAddress';
import ContactInfoEmail from '../ContactInfoEmail/ContactInfoEmail';
import { useRootStore } from '../../../../mobx/bridge';
import MatchedCustomer from '../MatchedCustomer/MatchedCustomer';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const ContactInfo = observer(function ContactInfo(props) {
  const { commonStore } = useRootStore();

  const { t } = useTranslation();

  const { contactToEdit, isWebChatChannel } = props;
  const { PhoneNumbers, Address, Emails, FetchedEmails } = contactToEdit;

  const innerContainerStyles = [styles.innerContainer];

  if (isWebChatChannel) {
    innerContainerStyles.push(styles.innerContainerWebChat);
  }
  if (commonStore?.displayEditCustomerNamesForm) {
    innerContainerStyles.push(styles.innerContainerEditCustomersName);
  }

  return (PhoneNumbers && PhoneNumbers.length > 0) ||
    (isWebChatChannel && Emails?.length > 0) ||
    (!isWebChatChannel && FetchedEmails?.length > 0) ||
    Address ||
    commonStore.contactInfoMatchedContacts?.length ? (
    <Grid
      component="div"
      container
      className={innerContainerStyles.join(' ')}
      alignContent="flex-start"
    >
      <Grid component="div" item xs={12} className={styles.separator}>
        {t('ContactInfo.CustomerInformation')}
      </Grid>

      {PhoneNumbers && PhoneNumbers.length > 0 ? (
        <Grid component="div" item xs={12} data-testid="phoneNumber">
          <div className={styles.editContactSeparator}>
            <span className={styles.editContactSeparatorText}>{t('ContactInfo.PhoneNumbers')}</span>
          </div>

          {PhoneNumbers.map((m) => (
            <ContactInfoPhoneNumber
              key={m._id}
              phone={m}
              contactToEdit={contactToEdit}
              isWebChatChannel={isWebChatChannel}
            />
          ))}
        </Grid>
      ) : null}

      {isWebChatChannel && Emails?.length > 0 ? (
        <Grid component="div" item xs={12} data-testid="email">
          <div className={styles.editContactSeparator}>
            <span className={styles.editContactSeparatorText}>
              {Emails.length > 1 ? t('ContactInfo.Emails') : t('ContactInfo.Email')}
            </span>
          </div>

          {Emails.map((e) => (
            <ContactInfoEmail
              key={e._id}
              email={e}
              contactToEdit={contactToEdit}
              isWebChatChannel={isWebChatChannel}
            />
          ))}
        </Grid>
      ) : null}

      {!isWebChatChannel && FetchedEmails?.length > 0 ? (
        <Grid component="div" item xs={12} data-testid="email">
          <div className={styles.editContactSeparator}>
            <span className={styles.editContactSeparatorText}>
              {FetchedEmails.length > 1 ? t('ContactInfo.Emails') : t('ContactInfo.Email')}
            </span>
          </div>

          {FetchedEmails.map((e) => (
            <ContactInfoEmail
              key={e}
              email={e}
              contactToEdit={contactToEdit}
              isWebChatChannel={isWebChatChannel}
            />
          ))}
        </Grid>
      ) : null}

      {Address ? (
        <Grid component="div" item xs={12} data-testid="address">
          <div className={styles.editContactSeparator}>
            <span className={styles.editContactSeparatorText}>{t('ContactInfo.Address')}</span>
          </div>

          <ContactInfoAddress address={Address} />
        </Grid>
      ) : null}

      {commonStore.contactInfoMatchedContacts?.length ? (
        <React.Fragment>
          <Grid component="div" item xs={12} className={styles.separator}>
            {t('ContactInfo.MatchedCustomers')}
          </Grid>

          <Grid component="div" item xs={12} data-testid="matched-customers">
            {commonStore.contactInfoMatchedContacts?.map((c) => (
              <MatchedCustomer
                key={c.customerId}
                customer={c}
                isWebChatChannel={isWebChatChannel}
              />
            ))}
          </Grid>
        </React.Fragment>
      ) : null}
    </Grid>
  ) : null;
});
ContactInfo.propTypes = {
  contactToEdit: PropTypes.object.isRequired, // eslint-disable-line
};
ContactInfo.whyDidYouRender = true;
ContactInfo.displayName = 'ContactInfo';

export default ContactInfo;
